import React from 'react';

const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

// Printim cilësor
export const IconPaper = ({ className }) => (
  <svg className={className} {...base}>
    <rect x="4" y="3" width="16" height="18" rx="1.5" />
    <path d="M8 8h8" />
    <path d="M8 12h8" />
    <path d="M8 16h5" />
  </svg>
);

// Kopertinë e fortë / qëndrueshmëri
export const IconHardcover = ({ className }) => (
  <svg className={className} {...base}>
    <path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v18H6.5A2.5 2.5 0 0 1 4 18.5v-13Z" />
    <path d="M4 18.5A2.5 2.5 0 0 1 6.5 16H20" />
  </svg>
);

// Paketim / dërgesë
export const IconGiftBox = ({ className }) => (
  <svg className={className} {...base}>
    <rect x="3" y="9" width="18" height="12" rx="1" />
    <path d="M3 13h18" />
    <path d="M12 9v12" />
    <path d="M12 9c-1.5-4-6-4-6-1s3 1 6 1" />
    <path d="M12 9c1.5-4 6-4 6-1s-3 1-6 1" />
  </svg>
);
